import { useState } from "preact/hooks";
import { SendIcon } from "./icons";

/** Text input for visitors who prefer typing (or can't use the mic right now). 16px font so iOS doesn't zoom. */
export function Composer({ disabled, onSend }: { disabled: boolean; onSend: (text: string) => void }) {
  const [text, setText] = useState("");
  const submit = (e: Event) => {
    e.preventDefault();
    const t = text.trim();
    if (!t || disabled) return;
    onSend(t);
    setText("");
  };
  return (
    <form class="wk-composer" onSubmit={submit}>
      <input
        type="text"
        value={text}
        maxLength={500}
        placeholder={disabled ? "Start a conversation to type…" : "Type a message…"}
        disabled={disabled}
        autocomplete="off"
        autocapitalize="sentences"
        enterkeyhint="send"
        onInput={(e) => setText((e.currentTarget as HTMLInputElement).value)}
        onFocus={(e) => (e.currentTarget as HTMLInputElement).scrollIntoView({ block: "nearest" })}
        aria-label="Type a message"
      />
      <button type="submit" class="wk-send" disabled={disabled || !text.trim()} aria-label="Send">
        <SendIcon />
      </button>
    </form>
  );
}
